/* tslint:disable */
/* eslint-disable */
/**
 * Order Portal
 * Order Portal
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateOrderLinesDTO } from './CreateOrderLinesDTO';
import {
    CreateOrderLinesDTOFromJSON,
    CreateOrderLinesDTOFromJSONTyped,
    CreateOrderLinesDTOToJSON,
    CreateOrderLinesDTOToJSONTyped,
} from './CreateOrderLinesDTO';

/**
 * 
 * @export
 * @interface UpdateOrderDto
 */
export interface UpdateOrderDto {
    /**
     * 
     * @type {Date}
     * @memberof UpdateOrderDto
     */
    docDueDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderDto
     */
    comments?: string;
    /**
     * 
     * @type {Array<CreateOrderLinesDTO>}
     * @memberof UpdateOrderDto
     */
    documentLines?: Array<CreateOrderLinesDTO>;
}

/**
 * Check if a given object implements the UpdateOrderDto interface.
 */
export function instanceOfUpdateOrderDto(value: object): value is UpdateOrderDto {
    return true;
}

export function UpdateOrderDtoFromJSON(json: any): UpdateOrderDto {
    return UpdateOrderDtoFromJSONTyped(json, false);
}

export function UpdateOrderDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateOrderDto {
    if (json == null) {
        return json;
    }
    return {
        
        'docDueDate': json['docDueDate'] == null ? undefined : (new Date(json['docDueDate'])),
        'comments': json['comments'] == null ? undefined : json['comments'],
        'documentLines': json['documentLines'] == null ? undefined : ((json['documentLines'] as Array<any>).map(CreateOrderLinesDTOFromJSON)),
    };
}

export function UpdateOrderDtoToJSON(json: any): UpdateOrderDto {
    return UpdateOrderDtoToJSONTyped(json, false);
}

export function UpdateOrderDtoToJSONTyped(value?: UpdateOrderDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'docDueDate': value['docDueDate'] == null ? undefined : ((value['docDueDate']).toISOString()),
        'comments': value['comments'],
        'documentLines': value['documentLines'] == null ? undefined : ((value['documentLines'] as Array<any>).map(CreateOrderLinesDTOToJSON)),
    };
}

